import React, { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { DeletePost, GetPost } from "../api/postapi";
import { PgInter } from "../interface/interface";
import { LoadingChange, ToastChange } from "../reducers/config";
import { officeApi } from "../api/config";

type GetPost = [
  any[],
  (data: any, id: string) => void,
  () => void,
  (text: string) => void,
  (ctts_id: string, ctts_stat_cd: "ctts_sts_nrml" | "ctts_sts_none") => void
];

const useGetPost = ({
  bbs_id,
  filter,
}: {
  bbs_id: number;
  filter?: string;
}): GetPost => {
  const dispatch = useDispatch();
  const [data, setData] = useState<any[]>([]);
  const [page, setPage] = useState<PgInter | null>(null);

  const Post_Get = useCallback(
    (text?: string) => {
      GetPost(bbs_id, 1, filter, text).then((result) => {
        const { state, data, msg } = result;
        if (state) {
          setData(data.lst);
          setPage(data.pg);
        } else {
          dispatch(ToastChange({ active: true, content: msg }));
        }
      });
    },
    [bbs_id, filter]
  );
  const PostStateChange = useCallback(
    (ctts_id: string, ctts_stat_cd: "ctts_sts_nrml" | "ctts_sts_none") => {
      officeApi
        .post(`/web/cmnt/2/ctts`, {
          bbs_id,
          ctts_id,
          ctts_stat_cd,
        })
        .then((res) => {
          Post_Get();
        });
    },
    [bbs_id, Post_Get]
  );

  const PagingUpdate = useCallback(() => {
    if (page) {
      const { page_next, page_last, page_cur } = page;
      if (page_cur < page_last) {
        GetPost(bbs_id, page_next).then(({ state, data: postData }) => {
          if (state && postData) {
            setPage(postData.pg);
            let clone = data ? data.slice() : [];
            clone = [...clone, ...postData.lst];
            setData(clone);
          }
        });
      }
    }
  }, [page, data]);
  const PostRemove = useCallback(
    (data: any, id: string) => {
      dispatch(LoadingChange(true));
      const obj = Object.assign(data, { bbs_id });
      DeletePost({
        data: obj,
        ctts_id: id,
      })
        .then(({ state }) => {
          if (state) {
            Post_Get();
            dispatch(LoadingChange(false));
          } else {
            dispatch(LoadingChange(false));
          }
        })
        .catch(() => {
          dispatch(LoadingChange(false));
        });
    },
    [bbs_id, data, dispatch, Post_Get]
  );
  const PostSearch = useCallback(
    (text: string) => {
      Post_Get(text);
    },
    [Post_Get]
  );

  useEffect(() => {
    Post_Get();
    return () => {};
  }, [Post_Get]);

  return [data, PostRemove, PagingUpdate, PostSearch, PostStateChange];
};

export default useGetPost;
